import Lookup from 'src/componentes/select2';

const FormatoUnidade = (props) => {
  return (
    <Lookup
      clearable={false}
      labelKey="descricao"
      valueKey="id"
      url="/FormatoUnidadeLookup"
      {...props}
    />
  );
};

export default FormatoUnidade;
